import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

import { cloneDeep } from 'lodash';

import { SelectieItem, VraagboomSelectieResultaat } from '@models/vragenboom';
import { Observable } from 'rxjs';
import { DataService } from '@components/public_api';
import { BaseOlsControlDirective } from '../base/base-ols-control';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-selectie',
  templateUrl: './selectie.component.html',
  styleUrls: ['./selectie.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectieComponent extends BaseOlsControlDirective implements OnInit {
  @Input() placeholder: string;
  @Input() filterAltijdTonen: string;
  _items: SelectieItem[];
  @Input() set items(itms: SelectieItem[]) {
    this._items = itms;
    this.gefilterdeItems = cloneDeep(itms);
  }
  get huidigeSelectie(): VraagboomSelectieResultaat {
    let item = this._items.find(i => i.code === this.selectedCode);
    return new VraagboomSelectieResultaat(item?.code, item?.titel, item?.omschrijving);
  }
  @Input() set huidigeSelectie(selectie: VraagboomSelectieResultaat) {
    this.selectedCode = selectie?.code ? selectie?.code : '';
    this.selectedOmschrijving = selectie?.omschrijving;
  }
  @Output() notifyAntwoordChanged = new EventEmitter();

  gefilterdeItems: SelectieItem[];
  _filter: string;
  get filter(): string {
    return this._filter;
  }
  set filter(val: string) {
    this._filter = val;
  }
  selectedCode: string;
  selectedOmschrijving: string;
  submitClicked$: Observable<boolean>;
  submitClicked: boolean;

  constructor(private _dataService: DataService) { super(); }

  ngOnInit() {
    this._filter = '';
    this.submitClicked$ = this._dataService.submitClicked;
    this.submitClicked$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(sc => {this.submitClicked = sc;});
  }

  clicked(code: string) {
    this.setResultaat(code);
  }

  wisFilter() {
    this._filter = '';
    this.gefilterdeItems = this._items;
  }

  onKey(event: KeyboardEvent) {
    this._filter = (event.target as HTMLInputElement).value;
    this.gefilterdeItems = this._items?.filter(i => i.filterwaarde.toLowerCase().includes(this._filter.toLowerCase()));
    if (this.filterAltijdTonen?.length > 0) {
      const index = this.gefilterdeItems.findIndex(f => f.filterwaarde.toLowerCase() === this.filterAltijdTonen);
      if (index === -1) {
        this.gefilterdeItems.push(this._items.find(i => i.filterwaarde.toLowerCase() === this.filterAltijdTonen));
      }
    }
    // als selectie niet in filter zit dan deselecteren
    if (this.gefilterdeItems.findIndex(f => f.code === this.selectedCode) === -1) {
      this.setResultaat('');
    }
  }

  setResultaat(code: string) {
    this.selectedCode = code;
    this.notifyAntwoordChanged.emit(this.huidigeSelectie)
  }
}
